import {RowType} from "../../../components/Editable/FormItem/Rows/RowType";

export function calculateDisplayNumbers(items) {
    function iterateArray(arr) {
        let counter = 0;

        return arr.map(record => {
            switch (record.type) {
                case RowType.subtotal:
                case RowType.subtitle:
                    counter = 0;
                    return {
                        ...record,
                        displayNumber: null,
                    };
                case RowType.bundle:
                    counter += 1;
                    return {
                        ...record,
                        displayNumber: counter,
                        children: iterateArray(record?.children || []),
                    };
                case RowType.item:
                case RowType.bundle_item:
                case RowType.bundle_discount:
                default:
                    counter += 1;
                    return {
                        ...record,
                        displayNumber: counter,
                    };
            }
        });
    }

    return iterateArray(items);
}
